import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Typography from "@mui/material/Typography";
import DialogTitleStyled from "components/shared/dialog/dialog-title-styled";
import { useTranslation } from "react-i18next";
import type { DialogBaseProps } from "shared/dialog/types";

interface Props extends DialogBaseProps {
  email: string;
  onSubmit: () => void;
}

export const ConfirmInviteDialog = (props: Props) => {
  const { t } = useTranslation();
  const { email } = props;

  return (
    <Dialog maxWidth="xs" open={props.isOpen}>
      <DialogTitleStyled title={t("dashboard.users.invite.title")} onClose={props.onClose} isOpen={props.isOpen} />
      <DialogContent>
        <Typography variant="caption" color={"primary.main"}>
          {t("dashboard.users.invite.description", { email: email })}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={() => props.onSubmit()}>
          {t("common.confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
